import { useSuggestionSearchBarContext } from '@aibees/elephant/feature/suggestion-search-bar/context';
import { useMemo } from 'react';
import { SuggestionSearchBarOptionBase } from '../../types';

export const useLookalikeButtonState = (
  item: SuggestionSearchBarOptionBase
) => {
  const { searchCategory } = useSuggestionSearchBarContext();

  return useMemo(() => {
    if (!item) {
      return { isDisabled: true, tooltipText: '' };
    }

    const isDisabled = !item.canSimilaritySearch;

    const tooltipText =
      searchCategory === 'people'
        ? `This contact doesn't contain enough information to perform a lookalike search.Please select a different contact profile.`
        : `This company doesn't contain enough information to perform a lookalike search.Please select a different company profile.`;

    const tooltipTextLimitReached =
      'You have Reached the Limit of 5 Lookalikes,\nRemove to Add new ones';

    return { isDisabled, tooltipText, tooltipTextLimitReached };
  }, [item, searchCategory]);
};
